import axiosLib from 'axios';

const axios = axiosLib.default || axiosLib;
// Get base URL from environment or config
const BASE_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:5000';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

/**
 * Request interceptor - Add token to all requests
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers['token'] = token;
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Response interceptor - Handle errors globally
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 - Unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    // Handle 403 - Forbidden
    if (error.response?.status === 403) {
      console.warn('Access denied');
    }

    // Handle 500 - Server error
    if (error.response?.status === 500) {
      console.error('Server error:', error.response.data);
    }

    return Promise.reject(error);
  }
);

/**
 * Generic API call factory
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {string} endpoint - API endpoint
 * @param {object} data - Request data (for POST/PUT)
 * @param {object} config - Additional axios config
 * @returns {Promise} API response promise
 */
const apiCall = (method, endpoint, data = null, config = {}) => {
  return apiClient({
    method,
    url: endpoint,
    data,
    ...config,
  });
};

// Export API methods
export default {
  get: (endpoint, config) => apiCall('GET', endpoint, null, config),
  post: (endpoint, data, config) => apiCall('POST', endpoint, data, config),
  put: (endpoint, data, config) => apiCall('PUT', endpoint, data, config),
  patch: (endpoint, data, config) => apiCall('PATCH', endpoint, data, config),
  delete: (endpoint, config) => apiCall('DELETE', endpoint, null, config),
  client: apiClient, // Export raw client for custom configurations
};